module.exports = __webpack_public_path__ + "static/img/icon1.107c9ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon1.jpg
// module id = J+/R
// module chunks = 25